module.exports = __webpack_public_path__ + "img/video10.1597768f.jpg";